import {
  Button,
  ButtonGroup,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  ModalTitle,
  Textarea,
} from '@apollo/orbit';
import { Global, css } from '@emotion/react';
import React, { useState } from 'react';

import { Form } from '../form/Form';

import { raw as ImageAstronautOnly } from './astronaut-only.svg';
import { raw as ImageFeedbackModalBackgroundPattern } from './feedback-modal-background-pattern.svg';

export const FeedbackModal = ({
  title = 'Any feedback for us?',
  message,
  onSubmit,
  isSubmitting,
  isOpen,
  onClose,
  footer,
}: {
  title?: React.ReactNode;
  message: React.ReactNode;
  footer?: React.ReactNode;
  onSubmit: (feedback: string) => void;
  isSubmitting: boolean;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const [feedback, setFeedback] = useState('');
  return (
    <>
      {/* TODO(react-18): An issue with emotion and chakra components causes a
         union too large TS error. To fix this we have to migrate away from the
         emotion jsx pragma. See DEBT-163 */}
      <Global
        styles={css`
          .xxx-feedback-modal {
            &:after {
              content: '';
              display: block;
              position: absolute;
              top: 80px;
              left: 0;
              right: 0;
              margin: 0 auto;
              width: 60px;
              height: 60px;
              background-image: url(${ImageAstronautOnly});
              animation: xxx-delete-account-float 5s ease-in-out infinite;
            }
            @keyframes xxx-delete-account-float {
              0% {
                transform: translateY(-4px);
              }
              50% {
                transform: translateY(4px);
              }
              100% {
                transform: translateY(-4px);
              }
            }
          }
        `}
      />
      <Modal isOpen={isOpen} onClose={onClose} size="2xl">
        <ModalOverlay />
        <Form
          className="relative"
          onSubmit={async (event) => {
            event.preventDefault();
            onSubmit(feedback);
            onClose();
          }}
          noValidate
        >
          <ModalContent>
            <ModalBody
              className="xxx-feedback-modal"
              style={{
                backgroundImage: `linear-gradient(to bottom, #ffffff00, #ffffffff 50%), url(${ImageFeedbackModalBackgroundPattern})`,
                paddingTop: 200,
              }}
            >
              <ModalTitle className="text-center">{title}</ModalTitle>
              <div className="text-center">
                <p className="mb-2">{message}</p>
                <FormControl>
                  <FormLabel className="sr-only">Feedback</FormLabel>
                  <Textarea
                    size="lg"
                    isDisabled={isSubmitting}
                    value={feedback}
                    onChange={(event) => {
                      setFeedback(event.target.value);
                    }}
                  />
                </FormControl>
                {footer && (
                  <div className="px-10 text-xs text-secondary">{footer}</div>
                )}
              </div>
            </ModalBody>
            <ModalFooter>
              <ButtonGroup>
                <Button
                  variant="secondary"
                  isDisabled={isSubmitting}
                  onClick={onClose}
                  type="button"
                >
                  No thanks
                </Button>
                <Button
                  variant="primary"
                  isLoading={isSubmitting}
                  loadingText="Let us know!"
                  type="submit"
                >
                  Let us know!
                </Button>
              </ButtonGroup>
            </ModalFooter>
          </ModalContent>
        </Form>
      </Modal>
    </>
  );
};
